import Vue from "vue";
import Router from "vue-router";
import i18n from "@/plugins/i18n";

const RootContainer = () => import("@/containers/RootContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");

// Views login
const Login = () => import("@/views/pages/login/Login");
const ForgotPassword = () => import("@/views/pages/login/ForgotPassword");
const FirstTimeLogin = () => import("@/views/pages/login/FirstTimeLogin");
const Success = () => import("@/views/pages/login/Success");
const partnerServiceList = () =>
  import("@/views/pages/partner/PartnerList/PartnersList.vue");
const addpartners = () =>
  import("@/views/pages/partner/addPartner/addPartner.vue");
const createpartners = () =>
  import("@/views/pages/partner/CreatePartner/createPartner.vue");
const createmanagers = () => import("@/views/pages/Manager/createManager.vue");
const detailpartners = () =>
  import("@/views/pages/partner/CreatePartner/detailPartner.vue");
const storemanagements = () =>
  import("@/views/pages/mig-partner/storemanagement.vue");
const createusers = () => import("@/views/pages/mig-partner/createuser.vue");
const userinfo = () => import("@/views/pages/mig-partner/userInfo.vue");
const createusersInfo = () =>
  import("@/views/pages/mig-partner/createuserinfo.vue");

const users = () => import("@/views/pages/mig-partner/user.vue");
const companyinformations = () =>
  import("@/views/pages/mig-partner/companyinfo.vue");
const managers = () => import("@/views/pages/mig-partner/manager.vue");
const addservice = () => import("@/views/pages/master/service/addService.vue");

const interviewSheet = () =>
  import("@/views/pages/service/interviewSheet/interviewSheet.vue");
const vrBrainPoints = () =>
  import("@/views/pages/service/vrBrainPoint/vrBrainPonit.vue");
const supplement = () =>
  import("@/views/pages/service/supplement/supplement.vue");
const vrBrainTraining = () =>
  import("@/views/pages/service/VRBrainTraining/VRBrainTraining.vue");
const Intestinalflora = () =>
  import("@/views/pages/service/intenstialFlora/intestinalFlora.vue");

const adminList = () => import("@/views/pages/admin/adminList/adminList.vue");

const masterUsers = () => import("@/views/pages/master/user/user.vue");
const inteviewClasification = () =>
  import(
    "@/views/pages/master/interviewClasification/inteviewClasification.vue"
  );
const partners = () => import("@/views/pages/master/partners/partners.vue");
const service = () => import("@/views/pages/master/service/service.vue");
const category = () => import("@/views/pages/master/category/category.vue");
const addcategory = () =>
  import("@/views/pages/master/category/addcategory.vue");

const userDetails = () => import("@/views/pages/userDetails.vue");
const SurveyHistory = () => import("@/views/pages/SurveyHistory.vue");
const SurveySummary = () => import("@/views/pages/SurveySummary.vue");
const VrTestResults = () => import("@/views/pages/VrTestResults.vue");
const VrTestResultHistory = () => import("@/views/pages/VrTestResultHistory.vue");
const VrTestResultDetails = () => import("@/views/pages/VrTestResultDetails.vue");

const userList = () => import("@/views/pages/partner/users/userList");
const createPartnerUser = () =>
  import("@/views/pages/partner/users/createUser");

const resetpassword = () => import("@/views/pages/login/ResetPassword");
const pagenotfound = () => import("@/views/pages/pageNotfound");
const profile = () => import("@/views/pages/profile");
const notification = () => import("@/views/pages/notification/notificationList");
const addnotification = () => import("@/views/pages/notification/addNotification");
const createStore = () =>
  import("@/views/pages/mig-partner/createStore.vue");
const MIGDashboard = () => import("@/views/MIGDashboard");
const partnernotification = () => import("@/views/pages/notification/partnerNotification");
const passwordchange = () => import("@/views/pages/changePassword");


import store from "./store/index.js";

import {
  checkPermisssionRole
} from "@/shared/utils.js";
import {
  filters
} from "./filters/common";
let MIG = filters.menuList;
Vue.use(Router);

const router = new Router({
  data() {
    return {
      user: store.state.menuList
    };
  },
  linkActiveClass: "open active",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
      path: "/",
      redirect: "/login",
      meta: {
        requiresAuth: false
      }
    },

    {
      path: "/ForgotPassword",
      name: "ForgotPassword",
      component: ForgotPassword,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/resetpassword/:token",
      name: "resetpassword",
      component: resetpassword,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/setPassword",
      name: "setPassword",
      component: FirstTimeLogin,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/success",
      name: "Success",
      component: Success,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "pagenotfound",
      name: "pagenotfound",
      component: pagenotfound,
      meta: {
        requiresAuth: false
      }

    },
    {
      path: "/",
      component: RootContainer,
      children: [{
          path: "MigDashboard",
          name: "MigDashboard",
          component: MIGDashboard,
          meta: {
            requiresAuth: true,
            breadcrumb: i18n.t("DASHBOARD"),
            MODULE: "MIG_DASHBOARD",
            MODULE_SUB: false,
            ACTION: 'read'
          },
        },
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: {
            breadcrumb: i18n.t("DASHBOARD"),
            requiresAuth: true,
            MODULE: "PARTNER_DASHBOARD",
            MODULE_SUB: false,
            ACTION: 'read'
          },
        },

        {
          path: "/partner_service_list",
          name: "partnersList",
          component: partnerServiceList,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER",
            MODULE_SUB: "PARTNER_LIST",
            ACTION: 'hide'
          }
        },
        {
          path: "/addpartner",
          name: "addpartner",
          component: addpartners,
          meta: {
            requiresAuth: true,
            MODULE: "MASTER",
            MODULE_SUB: "MASTER_PARTNER_CATEGORY",
            ACTION: "write"
          }
        },
        {
          path: "/editpartner/:id",
          name: "editpartner",
          component: addpartners,
          meta: {
            requiresAuth: true,
            MODULE: "MASTER",
            MODULE_SUB: "MASTER_PARTNER_CATEGORY",
            ACTION: "write"
          }
        },
        {
          path: "/createPartner",
          name: "createpartner",
          component: createpartners,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER",
            MODULE_SUB: "PARTNER_LIST",
            ACTION: 'write'
          }
        },
        {
          path: "/editServicepartner/:id",
          name: "editServicepartner",
          component: createpartners,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER",
            MODULE_SUB: "PARTNER_LIST",
            ACTION: 'write'
          }
        },

        {
          path: "/createManager",
          name: "createmanager",
          component: createmanagers,
          meta: {
            requiresAuth: true,
            MODULE: "ADMIN",
            MODULE_SUB: "ADMIN_LIST",
            ACTION: 'write'
          }
        },
        {
          path: "/editManager/:id",
          name: "editManager",
          component: createmanagers,
          meta: {
            requiresAuth: true,
            MODULE: "ADMIN",
            MODULE_SUB: "ADMIN_LIST",
            ACTION: 'write'
          }
        },
        {
          path: "/detailPartner/:id",
          name: "detailPartner",
          component: detailpartners,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER",
            MODULE_SUB: "PARTNER_LIST",
            ACTION: 'read'
          }
        },
        {
          path: "/storemanagement",
          name: "storemanagement",
          component: storemanagements,
          meta: {
            requiresAuth: true,
            MODULE: "BRANCH",
            MODULE_SUB: false,
            ACTION: 'read'
          }

        },
        {
          path: "/createuser",
          name: "createuser",
          component: createusers,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_USER",
            MODULE_SUB: false,
            ACTION: 'write'
          }
        },
        {
          path: "/edituser/:id",
          name: "edituser",
          component: createusers,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_USER",
            MODULE_SUB: false,
            ACTION: 'write'
          }
        },
        {
          path: "/userinfo",
          name: "userinfo",
          component: userinfo,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_USER",
            MODULE_SUB: false,
            ACTION: 'write'
          }
        },
        {
          path: "/userinfoDetails/:id",
          name: "userinfoDetails",
          component: userinfo,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_USER",
            MODULE_SUB: false,
            ACTION: 'write'
          }
        },
        {
          path: "/createuserinfo",
          name: "createuserinfo",
          component: createusersInfo,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_USER",
            MODULE_SUB: false,
            ACTION: 'write'
          }
        },
        {
          path: "/editpatient/:id",
          name: "editpatient",
          component: createusersInfo,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_USER",
            MODULE_SUB: false,
            ACTION: 'write'
          }
        },
        {
          path: "/user",
          name: "user",
          component: users,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_USER",
            MODULE_SUB: false,
            ACTION: 'hide'
          }
        },
        {
          path: "/companyinfo",
          name: "companyinfo",
          component: companyinformations,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_ABOUT",
            MODULE_SUB: false,
            ACTION: 'hide'
          }
        },
        {
          path: "/manager",
          name: "manager",
          component: managers,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/addService",
          name: "addservice",
          component: addservice,
          meta: {
            requiresAuth: true,
            MODULE: "MASTER",
            MODULE_SUB: "MASTER_SERVICE",
            ACTION: 'write'
          }
        },
        {
          path: "/editService/:id",
          name: "editService",
          component: addservice,
          meta: {
            requiresAuth: true,
            MODULE: "MASTER",
            MODULE_SUB: "MASTER_SERVICE",
            ACTION: 'write'
          }
        },

        {
          path: "/interviewsheet",
          name: "interviewsheet",
          component: interviewSheet,
          meta: {
            requiresAuth: true,
            MODULE: "QUESTIONNAIRE",
            MODULE_SUB: "QUESTIONNAIRE_LIST",
            ACTION: 'hide'
          }
        },
        {
          path: "/vrBrainPoints",
          name: "vrBrainPoints",
          component: vrBrainPoints,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/supplement",
          name: "supplement",
          component: supplement,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/vrBrainTraining",
          name: "vrBrainTraining",
          component: vrBrainTraining,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/Intestinalflora",
          name: "Intestinalflora",
          component: Intestinalflora,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "/adminlist",
          name: "adminList",
          component: adminList,
          meta: {
            requiresAuth: true,
            MODULE: "ADMIN",
            MODULE_SUB: "ADMIN_LIST",
            ACTION: "hide"
          }
        },

        {
          path: "/masterUsers",
          name: "masterUsers",
          component: masterUsers,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/inteviewClasification",
          name: "inteviewClasification",
          component: inteviewClasification,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/partners",
          name: "partners",
          component: partners,
          meta: {
            requiresAuth: true,
            MODULE: "MASTER",
            MODULE_SUB: "MASTER_PARTNER_CATEGORY",
            ACTION: "hide"
          }
        },
        {
          path: "/category",
          name: "category",
          component: category,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/addcategory",
          name: "addcategory",
          component: addcategory,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/service",
          name: "service",
          component: service,
          meta: {
            requiresAuth: true,
            MODULE: "MASTER",
            MODULE_SUB: "MASTER_PARTNER_CATEGORY",
            ACTION: "hide"
          }
        },
        {
          path: "/userDetails/:patientId",
          component: userDetails,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_USER",
            MODULE_SUB: false,
            ACTION: "read"
          },
          children: [
            {
              path: '',
              name: "SurveyHistory",
              component: SurveyHistory,
              meta: {
                requiresAuth: true,
                MODULE: "PARTNER_USER",
                MODULE_SUB: false,
                ACTION: "read"
              }
            },
            {
              path: 'surveySummary',
              name: "SurveySummary",
              component: SurveySummary,
              meta: {
                requiresAuth: true,
                MODULE: "PARTNER_USER",
                MODULE_SUB: false,
                ACTION: "read"
              }
            },            
            {
              path: 'vrTestResults',
              component: VrTestResults,
              meta: {
                requiresAuth: true,
                MODULE: "VR_TEST_RESULT",
                MODULE_SUB: false,
                ACTION: "read"
              },
              children: [
                {
                  path: '',
                  name: "VrTestResultHistory",
                  component: VrTestResultHistory,
                  meta: {
                    requiresAuth: true,
                    MODULE: "VR_TEST_RESULT",
                    MODULE_SUB: false,
                    ACTION: "read"
                  }
                },
                {
                  path: ':vrTestResultId',
                  name: "VrTestResultDetails",
                  component: VrTestResultDetails,
                  meta: {
                    requiresAuth: true,
                    MODULE: "VR_TEST_RESULT",
                    MODULE_SUB: false,
                    ACTION: "read"
                  }
                }
              ]
            }
          ]
        },
        {
          path: "userlist",
          name: "userlist",
          component: userList,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_ADMIN",
            MODULE_SUB: false,
            ACTION: "hide"
          }
        },
        {
          path: "createPartnerUser",
          name: "createPartnerUser",
          component: createPartnerUser,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_ADMIN",
            MODULE_SUB: false,
            ACTION: "write"
          }
        },
        {
          path: "editPartnerUser/:id",
          name: "editPartnerUser",
          component: createPartnerUser,
          meta: {
            requiresAuth: true,
            MODULE: "PARTNER_ADMIN",
            MODULE_SUB: false,
            ACTION: "write"
          }
        },
        {
          path: "/profile",
          name: "profile",
          component: profile,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/changepasscode",
          name: "passwordchange",
          component: passwordchange,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/notification",
          name: "notication",
          component: notification,
          meta: {
            requiresAuth: true,
            MODULE: "NOTIFICATION_MENU",
            MODULE_SUB: "NOTIFICATION",
            ACTION: 'hide'
          }
        },
        {
          path: "/addnotification",
          name: "addnotification",
          component: addnotification,
          meta: {
            requiresAuth: true,
            MODULE: "NOTIFICATION_MENU",
            MODULE_SUB: "NOTIFICATION",
            ACTION: 'write'
          }
        },
        {
          path: "/editNotification/:id",
          name: "editNotification",
          component: addnotification,
          meta: {
            requiresAuth: true,
            MODULE: "NOTIFICATION_MENU",
            MODULE_SUB: "NOTIFICATION",
            ACTION: 'write'
          }
        },
        {
          path: "/createStore",
          name: "createStore",
          component: createStore,
          meta: {
            requiresAuth: true,
            MODULE: "BRANCH",
            MODULE_SUB: false,
            ACTION: 'write'
          }
        },
        {
          path: "/createStore/:id",
          name: "createStoreEdit",
          component: createStore,
          meta: {
            requiresAuth: true,
            MODULE: "BRANCH",
            MODULE_SUB: false,
            ACTION: 'write'
          }
        },
        {
          path: "/partnernotification",
          name: "partnernotication",
          component: partnernotification,
          meta: {
            requiresAuth: true,
            MODULE: "NOTIFICATION_PARTNER",
            MODULE_SUB: false,
            ACTION: 'hide'
          }
        },

      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if ((to.name == null || to.name == "Login") && localStorage.getItem("token") != null) {
    let permissions = _.filter(
      store.state.auth.permissions,
      item => item.hide == 0
    );
    if (permissions.length != 0) {
      /* Find dashboard menu */
      let findDashboard = _.find(
        permissions,
        item =>
        item.module == "MIG_DASHBOARD" ||
        item.module == "PARTNER_DASHBOARD"
      );

      if (findDashboard) {
        let menuItem = _.find(
          MIG,
          item => item.module == findDashboard.module
        );
        next({
          name: menuItem.menuName
        })
      } else {
        let firstMenu = permissions[0];
        let menuItem = _.find(
          MIG,
          item => item.module == firstMenu.module
        );
        if (menuItem) {
          if (menuItem.submenu.length) {
            next({
              name: menuItem.submenu[0].menuName
            });
          } else {
            next({
              name: menuItem.menuName
            });
          }
        } else {
          next({
            name: 'Login'
          });
        }
      }


    } else {
      next();
    }
  } else if (to.meta.requiresAuth == true) {
    let getModule = checkPermisssionRole(to.meta.MODULE, to.meta.MODULE_SUB, to.meta.ACTION);
    if (localStorage.getItem("token") == null || !getModule) {
      //next({ name: "Login"});
      next({
        name: "pagenotfound"
      });
    } else {
      // router.push({name: 'login'})
      next();
    }
  } else {

    next();
  }
});

export default router
